"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blockquote = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const StyledBlockquote = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    position: relative;
    margin-left: 0;
    margin-right: 0;
    display: flex;
    padding-left: ${theme.spacing.unit * 4}px;
    padding-top: ${theme.spacing.unit}px;
    padding-bottom: ${theme.spacing.unit * 3}px;
    font-style: italic;

    &::before {
      content: '"';
      font-style: normal;
      position: absolute;
      left: 0;
      font-size: ${theme.spacing.unit * 6}px;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      top: -${theme.spacing.unit}px;
      background-color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
    }

    ${bitcoincom_pkg_theme_1.media.md `
      padding-left: ${theme.spacing.unit * 4}px;
      padding-top: ${theme.spacing.unit * 2}px;

      &::before {
        font-size: ${theme.spacing.unit * 8}px;
        top: -${theme.spacing.unit * 2}px;
      }
    `}
  `}
`;
/**
 * Blockquote component
 */
const Blockquote = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return react_1.default.createElement(StyledBlockquote, Object.assign({}, rest), children);
};
exports.Blockquote = Blockquote;
exports.default = exports.Blockquote;
//# sourceMappingURL=Blockquote.js.map